// The risk traffic light staff set on a Due Diligence case, shared by
// admin-interface (where staff set it) and user-interface (where the client
// reads it). Both apps had declared the same four values, and admin declared
// them twice more as inline casts.
//
// The spelling is data, not a local choice: it is the Postgres CHECK on
// due_diligence_cases.traffic_light_status (migration V0034) and the backend's
// TrafficLightStatus enum. Note it is NOT the report's semaphore vocabulary —
// this one says "yellow"/"unknown" where the report says "amber"/"neutral" —
// so the two cannot be merged without migrating the column.
//
// Deliberately free of zod: the apps resolve different zod versions (one
// hoisted to the repo root, one nested), and a schema declared here would be
// composed into schemas built by the other instance. Each app builds its own
// `z.enum(TRAFFIC_LIGHT_STATUSES)` from this tuple instead.

// Named members so no caller has to spell a status; the literals appear here
// once and nowhere else, and the tuple below is built from them.
export const TRAFFIC_LIGHT = {
  green: "green",
  yellow: "yellow",
  red: "red",
  unknown: "unknown",
} as const;

export const TRAFFIC_LIGHT_STATUSES = [
  TRAFFIC_LIGHT.green,
  TRAFFIC_LIGHT.yellow,
  TRAFFIC_LIGHT.red,
  TRAFFIC_LIGHT.unknown,
] as const;

export type TrafficLightStatus = (typeof TRAFFIC_LIGHT_STATUSES)[number];
